import React from "react";
import MyAppoinments from "./MyAppoinments";

const DashContent = () => {
  return (
    <div>
      <MyAppoinments></MyAppoinments>
    </div>
  );
};

export default DashContent;
